import DynamicBuilderComponent from './dynamic-builder/dynamic-builder.component';
import FieldSenseListComponent from './field-sense-list/field-sense-list.component';
import EditorConfig from './constants/editor-config.constant';
import "../fe-control";
import GPTDialogComponent from './gpt-dialog/gpt-dialog.component';
import SparkContainerComponent from './spark-container/spark-container.component';

const DEPENDENCIES = [
  'fe-control'
];

angular
  .module("app.dynamic-builder", DEPENDENCIES)
  .config(['$stateProvider', function($stateProvider) {
    $stateProvider
      .state("app.dynamic-builder", {
        url: "/dynamic-builder/:templateId?:links",
        template: "<dynamic-builder></dynamic-builder>",
        data: { title: "Dynamic Builder - Form Engine" },
        resolve: {
          authenticate: ['AuthService', (AuthService) => AuthService.user()]
        }
      });
  }])
  .run(['$state', 'FlashService', function($state, FlashService) {
    $state.defaultErrorHandler((error) => {
      if (!(error.detail).includes('Not Logged In')) {  //implied by pending redirect
        FlashService.error(`An error occured during navigation: ${error.detail}`);
      }

      if ($state.current.name !== "login") {
        $state.go('login', { }); // careful not to create an infinite loop here
      }
    });
  }])
  .component('dynamicBuilder', DynamicBuilderComponent)
  .component('gptDialog', GPTDialogComponent)
  .component('fieldSenseList', FieldSenseListComponent)
  .component('sparkContainer', SparkContainerComponent)
  .constant('EDITOR_CONFIG', EditorConfig);
